.root {
  display: flex;
  flex-direction: column;
  width: 264px;
  min-width: 264px;
  border-right: 1px solid var(--color-border);
  background: var(--color-surface);
}

.header {
  padding: 16px;
  border-bottom: 1px solid var(--color-border);
}

.newButton {
  width: 100%;
}

.list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.empty {
  margin: 12px 8px;
  color: var(--color-text-tertiary);
  font-size: 13px;
  line-height: 1.5;
}

.item {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: var(--radius-md);
  padding-right: 4px;
}

.item:hover {
  background: var(--color-surface-subtle);
}

.itemActive,
.itemActive:hover {
  background: var(--color-brand-primary-soft);
}

.itemButton {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border: none;
  background: transparent;
  color: var(--color-text);
  font: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: var(--radius-md);
}

.itemButton:disabled {
  cursor: default;
}

.itemIcon {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--color-text-secondary);
}

.itemActive .itemIcon {
  color: var(--color-brand-primary-strong);
}

.itemTitle {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13.5px;
}

.deleteButton {
  flex-shrink: 0;
  opacity: 0;
  color: var(--color-text-tertiary);
}

.item:hover .deleteButton,
.itemActive .deleteButton {
  opacity: 1;
}

@media (max-width: 900px) {
  .root {
    display: none;
  }
}
